export const GTP_BAR_RADIUS = 5;

export function roundedOuterBarPath(
  width: number,
  height: number,
  value: number,
  radius = GTP_BAR_RADIUS,
): string {
  const w = Math.max(width, 0);
  const h = Math.max(height, 0);
  if (w <= 0 || h <= 0) return '';

  const r = Math.min(Math.max(radius, 0), h / 2, w);
  const left = value < 0 ? r : 0;
  const right = value > 0 ? r : 0;

  return [
    `M${left},0`,
    `H${w - right}`,
    right ? `A${right},${right} 0 0 1 ${w},${right}` : `L${w},0`,
    `V${h - right}`,
    right ? `A${right},${right} 0 0 1 ${w - right},${h}` : `L${w},${h}`,
    `H${left}`,
    left ? `A${left},${left} 0 0 1 0,${h - left}` : `L0,${h}`,
    `V${left}`,
    left ? `A${left},${left} 0 0 1 ${left},0` : `L0,0`,
    'Z',
  ].join('');
}
